import useToast from '../useToast';
import { useMutation } from '@tanstack/react-query';
import { checkOrgPost } from '@/services/api/requests/public-screener';
import { TCheckOrganizationResponse } from '@/types/PublicScreener.types';
import { TCustomAxiosError } from '@/services/api';

const useCheckOrg = (onSuccessCallback: (orgSlug: string) => void) => {
  const toast = useToast();

  const { isPending, mutate, isSuccess } = useMutation({
    mutationFn: async ({ url, turnstileToken }: { url: string; turnstileToken: string | null }) => {
      if (!turnstileToken) {
        throw new Error('Turnstile token is required');
      }

      const data = await checkOrgPost(url, turnstileToken);

      return data;
    },
    onSuccess: (data: TCheckOrganizationResponse) => {
      onSuccessCallback(data.slug);

      window.scrollTo({ top: 0, behavior: 'instant' });

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          title: 'Error while checking organization',
        },
        error,
      );
    },
  });

  return { isPending, mutate, isSuccess };
};

export default useCheckOrg;
